import { render, staticRenderFns } from "./personaje-icon-3.vue?vue&type=template&id=3fbc125a&scoped=true&"
import script from "./personaje-icon-3.vue?vue&type=script&lang=js&"
export * from "./personaje-icon-3.vue?vue&type=script&lang=js&"
import style0 from "./personaje-icon-3.vue?vue&type=style&index=0&id=3fbc125a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbc125a",
  null
  
)

export default component.exports